import React from 'react';
import { Fab, Tooltip, useTheme } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledFab = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(3),
  right: theme.spacing(3),
  zIndex: 1000,
  background: theme.palette.mode === 'dark' 
    ? 'linear-gradient(135deg, #64b5f6 0%, #2286c3 100%)'
    : 'linear-gradient(135deg, #0259a5ff 0%, #1769aa 100%)',
  color: '#ffffff',
  boxShadow: theme.palette.mode === 'dark'
    ? '0 8px 32px rgba(100, 181, 246, 0.3)'
    : '0 8px 32px rgba(2, 89, 165, 0.3)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  '&:hover': {
    background: theme.palette.mode === 'dark'
      ? 'linear-gradient(135deg, #90caf9 0%, #42a5f5 100%)'
      : 'linear-gradient(135deg, #1769aa 0%, #0d47a1 100%)',
    boxShadow: theme.palette.mode === 'dark'
      ? '0 12px 40px rgba(100, 181, 246, 0.4)'
      : '0 12px 40px rgba(2, 89, 165, 0.4)',
    transform: 'translateY(-2px) scale(1.05)',
  },
  '&:active': {
    transform: 'translateY(0px) scale(0.98)',
  },
}));

/**
 * Floating Action Button component with theme support
 * @param {object} props
 * @param {React.ReactNode} props.children - Button icon/content
 * @param {function} props.onClick - Click handler
 * @param {string} [props.tooltip] - Tooltip text
 * @param {boolean} [props.disabled] - Disabled state
 * @param {object} [props.sx] - Additional styles
 */
const FloatingActionButton = ({ 
  children, 
  onClick, 
  tooltip = '', 
  disabled = false, 
  sx = {}, 
  ...rest 
}) => {
  const theme = useTheme();

  const fabButton = (
    <StyledFab
      disabled={disabled}
      onClick={onClick}
      sx={sx}
      className="chat-fab"
      {...rest}
    >
      {children}
    </StyledFab>
  );

  if (tooltip) {
    return (
      <Tooltip 
        title={tooltip} 
        placement="left"
        arrow
        componentsProps={{
          tooltip: {
            sx: {
              backgroundColor: theme.palette.mode === 'dark' ? '#333' : '#666',
              color: '#fff',
              fontSize: '0.875rem',
              fontWeight: 500,
            }
          }
        }}
      >
        {fabButton}
      </Tooltip>
    );
  }

  return fabButton;
};

export default FloatingActionButton;